import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './InvoiceTableHeader';
import InvoiceTableRow from './InvoiceTableRow';
// import InvoiceTableBlankSpace from './InvoiceTableBlankSpace';
// import InvoiceTableFooter from './InvoiceTableFooter';

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 10,
    // borderWidth: 1,
    // borderColor: '#000',
  },
});

const InvoiceItemsTable = ({ invoice }) => (
  <View style={styles.tableContainer}>
    <InvoiceTableHeader />
    <InvoiceTableRow items={invoice} />
    {/* <InvoiceTableBlankSpace rowsCount={11} />
    <InvoiceTableFooter items={invoice.items} /> */}
  </View>
);

export default InvoiceItemsTable;
